module.exports = "/images/applestore.png?8782ccfbd05696b1a155b742b8272fb5";